export function dataInRequest(params = {}) {
  return {
    type: '@uploadplanilhacliente/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@uploadplanilhacliente/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@uploadplanilhacliente/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@uploadplanilhacliente/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@uploadplanilhacliente/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@uploadplanilhacliente/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@uploadplanilhacliente/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@uploadplanilhacliente/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@uploadplanilhacliente/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@uploadplanilhacliente/RECORD_FILTERING',
    payload: { params },
  };
}
